import styles from './Card.module.css';

export default function CardComponent(props) {
    const item = props.item;

    return (
        <div className={styles.card}>
            {!props.hideThumbnail &&
                <picture>
                    <source type="image/webp" media="(min-width:750px)" srcSet={item.image1x + ' 1x, ' + item.image2x + ' 2x'} alt={item.alt} />
                    <source type="image/webp" media="(min-width:300px)" srcSet={item.imageM1x + ' 1x, ' + item.imageM2x + ' 2x'} alt={item.alt} />
                    <img src={item.image1x} alt={item.alt} className={styles.logoImg} />
                </picture>
            }
            <div className={styles.matter}>
                <span className={styles.date}> {item.date} </span>
                <div className={styles.title}>
                    {item.title}
                </div>
                <span className={styles.location}>
                    {item.subText}
                </span>

                {item.links && <div className={styles.linksToExternal}>
                    {
                        item.links.map(linkItem =>
                            <span key={linkItem.id}>
                                <a id='linkToOpenExternal' href={linkItem.hyperlink} target="_blank" rel="noreferrer" onClick={e => e.stopPropagation()}>{linkItem.linkTitle} </a>
                            </span>)
                    }
                </div>}
            </div>
        </div>
    )
}
